import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { EPATHS } from '../../routes/paths.enum';
import {COLORS, media, FONT_SIZE, FONT_WEIGHT} from '../../components/ui/theme';
import { ModalShell } from '../../components/ui/ModalShell';
import {
  ModalHeader,
  ModalHeaderTitle,
  ModalCloseBtn,
  ModalBody,
  ModalFooter,
  ButtonPrimary,
} from '../../components/ui/ModalDA';

/**
 * ModalRegister — Modal "compte non vérifié" affichée après login si user.isVerified=false.
 *
 * Migration P3 (2026-06-06) : MUI Dialog + Button + Typography + HighlightOffIcon → ModalShell + primitives DA.
 *   - A11y gratuite (ESC + scrollLock + focusTrap via ModalShell)
 *   - Croix cerclée DA standard (§12 sexies)
 *   - Bouton "Verify my Email" → ButtonPrimary
 *   - Lien "Change My Email" : style local (lien souligné, accent violet sur hover)
 *
 * Notice : `open` peut être conditionné par window.location.pathname pour éviter d'afficher
 * sur /change-email (cf. EPATHS.CHANGE_EMAIL).
 *
 * @see tasks/active/TRACK-2026-06-06-da-middleware-p3-batch1.md
 */

const Message = styled.p`
  margin: 0 0 1.25rem;
  font-size: ${FONT_SIZE.base};
  line-height: 1.5;
  color: ${COLORS.ink};
  text-align: center;
  ${media.sm`font-size: .9rem;`}
`;

const ChangeEmailLink = styled.a`
  display: block;
  margin-top: 0.875rem;
  text-align: center;
  color: ${COLORS.accent};
  font-weight: ${FONT_WEIGHT.semibold};
  font-size: ${FONT_SIZE.sm};
  cursor: pointer;
  text-decoration: underline;
  &:hover { color: ${COLORS.accentHover}; }
`;

function ModalRegister({ open, onClose, showResend }) {
  const { t } = useTranslation();
  /* Préserve le comportement legacy : ne pas afficher si on est déjà sur /change-email */
  const isOpen = open && window.location.pathname !== EPATHS.CHANGE_EMAIL;

  return (
    <ModalShell isOpen={isOpen} onClose={onClose} $width="32rem" aria-label={t('RegisterModalAria')}>
      <ModalHeader>
        <ModalHeaderTitle>{t('RegisterModalTitle')}</ModalHeaderTitle>
        <ModalCloseBtn onClick={onClose} aria-label={t('RegisterModalCloseAria')}>✕</ModalCloseBtn>
      </ModalHeader>
      <ModalBody>
        <Message>
          {t('RegisterModalMessage')}
        </Message>
      </ModalBody>
      <ModalFooter>
        <ButtonPrimary onClick={showResend}>{t('RegisterModalVerifyBtn')}</ButtonPrimary>
      </ModalFooter>
      <ChangeEmailLink onClick={() => { window.location.href = EPATHS.CHANGE_EMAIL; }}>
        {t('RegisterModalChangeEmail')}
      </ChangeEmailLink>
    </ModalShell>
  );
}

export default ModalRegister;
